import { render, staticRenderFns } from "./single-checkbox-field.vue?vue&type=template&id=83287e12&scoped=true"
import script from "./single-checkbox-field.vue?vue&type=script&lang=ts"
export * from "./single-checkbox-field.vue?vue&type=script&lang=ts"
import style0 from "./single-checkbox-field.vue?vue&type=style&index=0&id=83287e12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83287e12",
  null
  
)

export default component.exports